import { ContentfulComponentHero, ContentfulHeroSection } from '@reward-platform/shared-schemas'

export const getHeroWithVariant = (
  hero: ContentfulComponentHero | ContentfulHeroSection | undefined
): ContentfulHeroSection | undefined => {
  if (!hero) {
    return undefined
  }
  if ('variant' in hero) {
    return {
      entryId: hero.variant?.identifier,
      heading: hero.variant?.heading,
      image: hero.variant?.image,
      body: 'bodyCopy' in hero ? hero.variant?.bodyCopy : hero.variant?.body,
    }
  }
  if ('bodyCopy' in hero) {
    return {
      entryId: hero.identifier,
      heading: hero.heading,
      image: hero.image,
      body: hero.bodyCopy,
    }
  }
  return hero
}
